import { IEagleviewProductData } from "common/records/EagleviewProduct";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_EAGLEVIEW_PRODUCT = "@eagleviewProducts/RECEIVE_EAGLEVIEW_PRODUCT";
export const RECEIVE_EAGLEVIEW_PRODUCTS = "@eagleviewProducts/RECEIVE_EAGLEVIEW_PRODUCTS";

export const EagleviewProductActions = {
  receiveEagleviewProducts: (eagleviewProducts: Partial<IEagleviewProductData>[]) =>
    createAction(RECEIVE_EAGLEVIEW_PRODUCTS, { eagleviewProducts }),
  receiveEagleviewProduct: (eagleviewProduct: Partial<IEagleviewProductData>) =>
    createAction(RECEIVE_EAGLEVIEW_PRODUCT, { eagleviewProduct }),
};

export type EagleviewProductActions = ActionsUnion<typeof EagleviewProductActions>;
